<template>
    <el-carousel :interval="5000"  height="290px">
        <el-carousel-item v-for="item in imgList" :key="item.id" >
          <div class="carousel-explain">
            <img :src="item.idView" style="width:100%;height:280px;left:0px;top:10px;position:absolute;z-index:-1;"/>
            <p style="font-size:36px;">{{item.name}}</p>
          </div>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
  data () {
    return {
      imgList: [
        { id: 0, name: '智慧物联，改变你我生活', idView: require('@/assets/image/banner0.png') },
        { id: 1, name: '防伪溯源，铸就你我安全', idView: require('@/assets/image/banner1.png') },
        { id: 2, name: '社区服务，互助彼此心声', idView: require('@/assets/image/banner2.png') },
        { id: 3, name: '咨询服务，沟通你我成就', idView: require('@/assets/image/banner3.png') }
      ]
    }
  }
}

</script>
